


exports.DNSPacket = require('./dnspacket');
exports.DNSRecord = require('./dnsrecord');
exports.errors = require('./errors');
exports.parse = exports.DNSPacket.parse;

